(function ($) {

	"use strict";

    $.enhancer("expandableForm", function () {

        const clickedForm = $(this).next();
        const clickedInputControl = $(this).find($('.custom-control-input'));
        const ariaAttributeValues = ['true', 'false'];

        const handleAriaAttributes = (element, attribute, value) => {
            if ($(element).attr(attribute) == value[0]) {
                $(element).attr(attribute, value[1]);
            } else if ($(element).attr(attribute) == value[1]) {
                $(element).attr(attribute, value[0]);
            }
        };

        $(this).on('click : focus', (e) => {
            // Reset values and visibility for items that were not clicked
            $('.expandable-form').not(clickedForm).slideUp();
            $('.expandable-form').not(clickedForm).attr('aria-hidden', 'true');
            $('.custom-control-input').not(clickedInputControl).attr('aria-expanded', 'false');

            // Set values and visibility for the clicked item
            clickedForm.slideDown();
            handleAriaAttributes(clickedForm, 'aria-hidden', ariaAttributeValues);
            handleAriaAttributes(clickedInputControl, 'aria-expanded', ariaAttributeValues);
        });

    });

})(jQuery);